import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader } from '../../components/components'
import HellocianDetailsForm from '../../components/admins/HellocianDetailsForm'

const AddNewHellocian = () => {
    return (

        <AdminSidebarLayout currentPath="/add-new-gig">
            <div className="bg-[#F5F5F5] dark:bg-[#121212] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                  <HellocianDetailsForm/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default AddNewHellocian